import React from 'react';
import { connect } from 'react-redux';
import { Fieldset, track } from 'react-redux-form';
import { Alert, Icon } from 'antd';

import Select from 'components/Fields/Select';
import { getLabels } from 'helpers/activityHelpers';
import { getActivity } from 'modules/activities-management';

import ControlMap from './Controls/ControlMap';
import ControlDates from './Controls/ControlDates';
import ControlParticipants from './Controls/ControlParticipants';
import ControlDescription from './Controls/ControlDescription';
import ControlText from './Controls/ControlText';
import ControlList from './Controls/ControlList';

class FormActivity extends React.Component {
  state = {
    activityType: null,
  };

  componentDidMount () {
    const { updateActivityType } = this;
    const { activity: { type }, activityTypes } = this.props;
    updateActivityType(getActivity(activityTypes, type.split(',')[1]));
  }

  componentDidUpdate (prevProps) {
    const { activity: { type: prevType } } = prevProps;
    const { updateActivityType } = this;
    const { activity: { type: newType }, activityTypes } = this.props;
    if (newType && newType !== prevType) {
      updateActivityType(getActivity(activityTypes, newType.split(',')[1]));
    }
  }

  // Find activity by key
  handleActivityChange = activityType => {
    const { updateActivityType } = this;
    const { activityTypes } = this.props;
    updateActivityType(getActivity(activityTypes, activityType.split(',')[1]));
  }

  updateActivityType = activityType => this.setState({ activityType });

  render () {
    const { handleActivityChange } = this;

    const { activityType } = this.state;
    const {
      features,
      activity,
      activity: { uid, eventDates },
      activities,
      updateRequestProperties,
      activityTypes,
    } = this.props;

    return (
      <Fieldset model={track('.properties.activities', ({ uid: actUid }) => actUid === uid)}>
        <Select
          label="Type d'activité"
          model=".type"
          placeholder="Saisissez ou sélectionnez une activité"
          options={getLabels(activityTypes)}
          errorMessages={{ required: { message: 'Le choix du type d\'activité est obligatoire' } }}
          categories
          showSearch
          onChange={handleActivityChange}
        />
        <Alert
          style={{ color: '#1b6fa3' }}
          message={(
            <React.Fragment>
              <Icon type="info-circle-o" /> Si votre activité ne figure pas dans la liste,
              veuillez nous contacter par mail &nbsp;
              <a href={`mailto:autorisations.fontainebleau@onf.fr?subject=${encodeURIComponent("Déclaration d'activité : proposition d'activité manquante")}`}>
                autorisations.fontainebleau@onf.fr
              </a> afin que nous examinions son éligibilité.
              Nous vous répondrons dans les plus brefs délais.
            </React.Fragment>
          )}
          type="info"
        />
        {activityType && activityType.value.controls.map(({ type, name, ...controlProps }) => {
          switch (type) {
            case 'description':
              return <ControlDescription key={name} />;
            case 'participants':
              return <ControlParticipants key={name} {...this.props} />;
            case 'dates':
              return (
                <ControlDates
                  key={name}
                  eventDates={eventDates}
                  activities={activities}
                  activity={activity}
                  updateRequestProperties={updateRequestProperties}
                  features={features}
                />
              );
            case 'location':
              return (
                <ControlMap
                  key={name}
                  features={features}
                  activity={activity}
                  {...this.props}
                />
              );
            case 'text':
              return <ControlText key={name} name={name} {...controlProps} />;
            case 'list':
              return <ControlList key={name} name={name} {...controlProps} />;
            default:
              return null;
          }
        })}
      </Fieldset>
    );
  }
}

const StateToProps = (state, ownProps) => ({
  features: ownProps.geojson || state.userrequest.geojson.features,
});

export default connect(StateToProps, null)(FormActivity);



// WEBPACK FOOTER //
// ./src/components/Form/FormActivity/index.js